import { DatePicker, Text, DayOfWeek, defaultDatePickerStrings, IDatePickerStrings, Stack, TextField, useTheme, Label, MessageBar, MessageBarType, ComboBox, IComboBoxOption } from '@fluentui/react';
import * as React from 'react';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { CzDatePickerStrings, getAge } from '../../../Tools/DateTime';
import { validateEmail } from '../../../Tools/Validation';
import { maxAgeOdchod } from '../../Consts';

interface IAttendeeDetailFormProps {
    item: IAttendee;

    isLoading: boolean;
    propertyChanged: (key: string, value: any) => void;
    valid: (value: boolean) => void;

    minAge?: number;
    maxAge?: number;
    paddingTop: number;
}

export const zdravotniPojistovny: IComboBoxOption[] = [
    {
        key: "111",
        text:"111 - Všeobecná zdravotní pojišťovna"
    },
    {
        key: "201",
        text: "201 - Vojenská zdravotní pojišťovna České republiky"
    },
    {
        key: "205",
        text: "205 - Česká průmyslová zdravotní pojišťovna"
    },
    {
        key: "207",
        text: "207 - Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví"
    },
    {
        key: "209",
        text: "209 - Zaměstnanecká pojišťovna Škoda"
    },
    {
        key: "211",
        text: "211 - Zdravotní pojišťovna ministerstva vnitra České republiky"
    },
    {
        key: "213",
        text: "213 - Revírní bratrská pokladna"
    },


]

export const AttendeeDetailForm: React.FunctionComponent<IAttendeeDetailFormProps> = (props) => {

    const theme = useTheme();

    const onFormatDate = (date?: Date): string => {
        return !date ? '' : date.getDate() + '.' + (date.getMonth() + 1) + '.' + (date.getFullYear());
    };

    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }
 

    const checkAge = () => {
       

        if (props.item && props.minAge && props.maxAge) {
            const age = getAge(props.item.dateOfBirth);
            return (age >= props.minAge && age <= props.maxAge);
        }
        return (!props.minAge && !props.maxAge);
    }

const validate = (item: IAttendee) => {
    const valid: boolean = item.firstName != "" &&
        item.lastName !== "" &&
        item.street !== "" &&
        item.city !== "" &&
        item.postalCode !== "" &&
        (getAge(props.item.dateOfBirth) < maxAgeOdchod ? item.insurance !== "":true) &&       
        getAge(props.item.dateOfBirth) > 2 &&
        (item.email !== "" && item.email !== null && validateEmail(item.email) != null) &&

        checkAge();
        props.valid(valid);
    }

    React.useEffect(() => {
        validate(props.item);
    }, [props.item])

    const onParseDateFromString = React.useCallback(
        (newValue: string): Date => {
            const previousValue = props.item.dateOfBirth as Date || new Date();
            const newValueParts = (newValue || '').trim().split('.');
            const day =
                newValueParts.length > 0 ? Math.max(1, Math.min(31, parseInt(newValueParts[0], 10))) : previousValue.getDate();
            const month =
                newValueParts.length > 1
                    ? Math.max(1, Math.min(12, parseInt(newValueParts[1], 10))) - 1
                    : previousValue.getMonth();
            let year = newValueParts.length > 2 ? parseInt(newValueParts[2], 10) : previousValue.getFullYear();
            if (year < 100) {
                year += previousValue.getFullYear() - (previousValue.getFullYear() % 100);
            }
            return new Date(year, month, day);
        },
        [props.item.dateOfBirth],
    );

    return (<Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: props.paddingTop } }}>

        <Stack>
            <Stack horizontal horizontalAlign="stretch" tokens={{ childrenGap: 10 }} verticalAlign="end">
                <DatePicker styles={{ root: { width: 150 } }}
                    label="Datum narození"
                    disabled={props.isLoading}
                    isRequired
                    value={props.item.dateOfBirth as Date}
                    onSelectDate={(date: Date | null | undefined) => { props.propertyChanged("dateOfBirth", date); }}

                    allowTextInput
                    firstDayOfWeek={DayOfWeek.Monday}
                    firstWeekOfYear={1}
                    placeholder="Vyberte datum narození"
                    ariaLabel="Vyberte datum narození"
                    strings={CzDatePickerStrings}
                    formatDate={onFormatDate}
                    parseDateFromString={onParseDateFromString}
                />
                <Label styles={{ root: { width: 90, color: !checkAge() ? theme.semanticColors.errorText : theme.semanticColors.successText } }}>Věk {getAge(props.item.dateOfBirth)} let</Label>
            </Stack>
            {!checkAge() && (props.item.lastName && props.item.lastName != "" && props.item.firstName && props.item.firstName != "") ?
                <MessageBar messageBarType={MessageBarType.error} >Tento kurz je určen pro věkovou skupinu {props.minAge} - {props.maxAge} let. Aktuálnímu žáku je {props.item ? getAge(props.item.dateOfBirth) : ""} <br />
                    prosím upravte datum narození, nebo vyberte jinou akci
                </MessageBar>
                : null
            }
        </Stack>
        {getAge(props.item.dateOfBirth) >= maxAgeOdchod ? <TextField id="degree" key="degree" label="Titul" disabled={props.isLoading} styles={{ root: { maxWidth: 150 } }} value={props.item.degree}
            onChange={propertyChanged} /> : null}
        <TextField required id="firstName" key="firstName" label="Jméno" disabled={props.isLoading} value={props.item.firstName}
            onChange={propertyChanged} />

        <TextField required id="lastName" key="lastName" label="Příjmení" disabled={props.isLoading} value={props.item.lastName}
            onChange={propertyChanged} />
        {getAge(props.item.dateOfBirth) >= maxAgeOdchod ? <TextField id="degreeAfterName" key="degreeAfterName" label="Titul za " disabled={props.isLoading} styles={{ root: { maxWidth: 150 } }} value={props.item.degreeAfterName}
            onChange={propertyChanged} /> : null}

        {getAge(props.item.dateOfBirth) < maxAgeOdchod ?
            <>
                < ComboBox required label="Zdravotní pojišťovna" options={zdravotniPojistovny} disabled={props.isLoading} selectedKey={props.item.insurance} onChange={(e, o, i, v) => {
                    props.propertyChanged("insurance", o?.key);
                }} />

                <TextField id="medicalNotes" key="medicalNotes" label="Poznámky ke zdravotnímu stavu, jiné" multiline disabled={props.isLoading} value={props.item.medicalNotes}
                    onChange={propertyChanged} />
            </> : null}

        <TextField required id="street" key="street" label="Ulice" disabled={props.isLoading} value={props.item.street}
            onChange={propertyChanged} />

        <TextField required id="city" key="city" label="Město" disabled={props.isLoading} value={props.item.city}
            onChange={propertyChanged} />

        <TextField required id="postalCode" key="postalCode" label="PSČ" disabled={props.isLoading} value={props.item.postalCode}
            onChange={propertyChanged} />

        <TextField id="email" key="email" label="Email" disabled={props.isLoading} value={props.item.email}
            onChange={propertyChanged} />

        <TextField id="phoneNumber" key="phoneNumber" label="Telefon" disabled={props.isLoading} value={props.item.phoneNumber}
            onChange={propertyChanged} />

        


    </Stack>)
}
